export interface CountryData {
  name: string;
  iso: string;
  dial: string;
  digits: number;
}

export const COUNTRIES: CountryData[] = [
  { name: 'Afghanistan', iso: 'AF', dial: '+93', digits: 9 },
  { name: 'Albania', iso: 'AL', dial: '+355', digits: 8 },
  { name: 'Algeria', iso: 'DZ', dial: '+213', digits: 9 },
  { name: 'Andorra', iso: 'AD', dial: '+376', digits: 6 },
  { name: 'Angola', iso: 'AO', dial: '+244', digits: 9 },
  { name: 'Argentina', iso: 'AR', dial: '+54', digits: 10 },
  { name: 'Armenia', iso: 'AM', dial: '+374', digits: 8 },
  { name: 'Australia', iso: 'AU', dial: '+61', digits: 9 },
  { name: 'Austria', iso: 'AT', dial: '+43', digits: 10 },
  { name: 'Azerbaijan', iso: 'AZ', dial: '+994', digits: 9 },
  { name: 'Bahrain', iso: 'BH', dial: '+973', digits: 8 },
  { name: 'Bangladesh', iso: 'BD', dial: '+880', digits: 10 },
  { name: 'Belarus', iso: 'BY', dial: '+375', digits: 9 },
  { name: 'Belgium', iso: 'BE', dial: '+32', digits: 9 },
  // Benin moved to 10-digit numbers (01 prefix) on 30 November 2024.
  { name: 'Benin', iso: 'BJ', dial: '+229', digits: 10 },
  { name: 'Bhutan', iso: 'BT', dial: '+975', digits: 8 },
  { name: 'Bolivia', iso: 'BO', dial: '+591', digits: 8 },
  { name: 'Bosnia and Herzegovina', iso: 'BA', dial: '+387', digits: 8 },
  { name: 'Botswana', iso: 'BW', dial: '+267', digits: 8 },
  { name: 'Brazil', iso: 'BR', dial: '+55', digits: 11 },
  { name: 'Brunei', iso: 'BN', dial: '+673', digits: 7 },
  { name: 'Bulgaria', iso: 'BG', dial: '+359', digits: 9 },
  { name: 'Burkina Faso', iso: 'BF', dial: '+226', digits: 8 },
  { name: 'Burundi', iso: 'BI', dial: '+257', digits: 8 },
  { name: 'Cambodia', iso: 'KH', dial: '+855', digits: 9 },
  { name: 'Cameroon', iso: 'CM', dial: '+237', digits: 9 },
  { name: 'Canada', iso: 'CA', dial: '+1', digits: 10 },
  { name: 'Cape Verde', iso: 'CV', dial: '+238', digits: 7 },
  { name: 'Central African Republic', iso: 'CF', dial: '+236', digits: 8 },
  { name: 'Chad', iso: 'TD', dial: '+235', digits: 8 },
  { name: 'Chile', iso: 'CL', dial: '+56', digits: 9 },
  { name: 'China', iso: 'CN', dial: '+86', digits: 11 },
  { name: 'Colombia', iso: 'CO', dial: '+57', digits: 10 },
  { name: 'Comoros', iso: 'KM', dial: '+269', digits: 7 },
  { name: 'Congo', iso: 'CG', dial: '+242', digits: 9 },
  { name: 'Costa Rica', iso: 'CR', dial: '+506', digits: 8 },
  { name: 'Croatia', iso: 'HR', dial: '+385', digits: 9 },
  { name: 'Cuba', iso: 'CU', dial: '+53', digits: 8 },
  { name: 'Cyprus', iso: 'CY', dial: '+357', digits: 8 },
  { name: 'Czech Republic', iso: 'CZ', dial: '+420', digits: 9 },
  { name: 'Denmark', iso: 'DK', dial: '+45', digits: 8 },
  { name: 'Djibouti', iso: 'DJ', dial: '+253', digits: 8 },
  { name: 'Dominican Republic', iso: 'DO', dial: '+1', digits: 10 },
  { name: 'DR Congo', iso: 'CD', dial: '+243', digits: 9 },
  { name: 'Ecuador', iso: 'EC', dial: '+593', digits: 9 },
  { name: 'Egypt', iso: 'EG', dial: '+20', digits: 10 },
  { name: 'El Salvador', iso: 'SV', dial: '+503', digits: 8 },
  { name: 'Equatorial Guinea', iso: 'GQ', dial: '+240', digits: 9 },
  { name: 'Eritrea', iso: 'ER', dial: '+291', digits: 7 },
  { name: 'Estonia', iso: 'EE', dial: '+372', digits: 8 },
  { name: 'Eswatini', iso: 'SZ', dial: '+268', digits: 8 },
  { name: 'Ethiopia', iso: 'ET', dial: '+251', digits: 9 },
  { name: 'Fiji', iso: 'FJ', dial: '+679', digits: 7 },
  { name: 'Finland', iso: 'FI', dial: '+358', digits: 9 },
  { name: 'France', iso: 'FR', dial: '+33', digits: 9 },
  { name: 'Gabon', iso: 'GA', dial: '+241', digits: 8 },
  { name: 'Gambia', iso: 'GM', dial: '+220', digits: 7 },
  { name: 'Georgia', iso: 'GE', dial: '+995', digits: 9 },
  { name: 'Germany', iso: 'DE', dial: '+49', digits: 11 },
  { name: 'Ghana', iso: 'GH', dial: '+233', digits: 9 },
  { name: 'Greece', iso: 'GR', dial: '+30', digits: 10 },
  { name: 'Guatemala', iso: 'GT', dial: '+502', digits: 8 },
  { name: 'Guinea', iso: 'GN', dial: '+224', digits: 9 },
  { name: 'Guinea-Bissau', iso: 'GW', dial: '+245', digits: 7 },
  { name: 'Haiti', iso: 'HT', dial: '+509', digits: 8 },
  { name: 'Honduras', iso: 'HN', dial: '+504', digits: 8 },
  { name: 'Hong Kong', iso: 'HK', dial: '+852', digits: 8 },
  { name: 'Hungary', iso: 'HU', dial: '+36', digits: 9 },
  { name: 'Iceland', iso: 'IS', dial: '+354', digits: 7 },
  { name: 'India', iso: 'IN', dial: '+91', digits: 10 },
  { name: 'Indonesia', iso: 'ID', dial: '+62', digits: 10 },
  { name: 'Iran', iso: 'IR', dial: '+98', digits: 10 },
  { name: 'Iraq', iso: 'IQ', dial: '+964', digits: 10 },
  { name: 'Ireland', iso: 'IE', dial: '+353', digits: 9 },
  { name: 'Israel', iso: 'IL', dial: '+972', digits: 9 },
  { name: 'Italy', iso: 'IT', dial: '+39', digits: 10 },
  { name: 'Ivory Coast', iso: 'CI', dial: '+225', digits: 10 },
  { name: 'Jamaica', iso: 'JM', dial: '+1', digits: 10 },
  { name: 'Japan', iso: 'JP', dial: '+81', digits: 10 },
  { name: 'Jordan', iso: 'JO', dial: '+962', digits: 9 },
  { name: 'Kazakhstan', iso: 'KZ', dial: '+7', digits: 10 },
  { name: 'Kenya', iso: 'KE', dial: '+254', digits: 9 },
  { name: 'Kuwait', iso: 'KW', dial: '+965', digits: 8 },
  { name: 'Kyrgyzstan', iso: 'KG', dial: '+996', digits: 9 },
  { name: 'Laos', iso: 'LA', dial: '+856', digits: 9 },
  { name: 'Latvia', iso: 'LV', dial: '+371', digits: 8 },
  { name: 'Lebanon', iso: 'LB', dial: '+961', digits: 8 },
  { name: 'Lesotho', iso: 'LS', dial: '+266', digits: 8 },
  { name: 'Liberia', iso: 'LR', dial: '+231', digits: 8 },
  { name: 'Libya', iso: 'LY', dial: '+218', digits: 9 },
  { name: 'Lithuania', iso: 'LT', dial: '+370', digits: 8 },
  { name: 'Luxembourg', iso: 'LU', dial: '+352', digits: 9 },
  { name: 'Madagascar', iso: 'MG', dial: '+261', digits: 9 },
  { name: 'Malawi', iso: 'MW', dial: '+265', digits: 9 },
  { name: 'Malaysia', iso: 'MY', dial: '+60', digits: 9 },
  { name: 'Mali', iso: 'ML', dial: '+223', digits: 8 },
  { name: 'Mauritania', iso: 'MR', dial: '+222', digits: 8 },
  { name: 'Mauritius', iso: 'MU', dial: '+230', digits: 8 },
  { name: 'Mexico', iso: 'MX', dial: '+52', digits: 10 },
  { name: 'Moldova', iso: 'MD', dial: '+373', digits: 8 },
  { name: 'Monaco', iso: 'MC', dial: '+377', digits: 8 },
  { name: 'Mongolia', iso: 'MN', dial: '+976', digits: 8 },
  { name: 'Montenegro', iso: 'ME', dial: '+382', digits: 8 },
  { name: 'Morocco', iso: 'MA', dial: '+212', digits: 9 },
  { name: 'Mozambique', iso: 'MZ', dial: '+258', digits: 9 },
  { name: 'Myanmar', iso: 'MM', dial: '+95', digits: 9 },
  { name: 'Namibia', iso: 'NA', dial: '+264', digits: 9 },
  { name: 'Nepal', iso: 'NP', dial: '+977', digits: 10 },
  { name: 'Netherlands', iso: 'NL', dial: '+31', digits: 9 },
  { name: 'New Zealand', iso: 'NZ', dial: '+64', digits: 9 },
  { name: 'Niger', iso: 'NE', dial: '+227', digits: 8 },
  { name: 'Nigeria', iso: 'NG', dial: '+234', digits: 10 },
  { name: 'North Korea', iso: 'KP', dial: '+850', digits: 10 },
  { name: 'North Macedonia', iso: 'MK', dial: '+389', digits: 8 },
  { name: 'Norway', iso: 'NO', dial: '+47', digits: 8 },
  { name: 'Oman', iso: 'OM', dial: '+968', digits: 8 },
  { name: 'Pakistan', iso: 'PK', dial: '+92', digits: 10 },
  { name: 'Palestine', iso: 'PS', dial: '+970', digits: 9 },
  { name: 'Panama', iso: 'PA', dial: '+507', digits: 8 },
  { name: 'Papua New Guinea', iso: 'PG', dial: '+675', digits: 8 },
  { name: 'Paraguay', iso: 'PY', dial: '+595', digits: 9 },
  { name: 'Peru', iso: 'PE', dial: '+51', digits: 9 },
  { name: 'Philippines', iso: 'PH', dial: '+63', digits: 10 },
  { name: 'Poland', iso: 'PL', dial: '+48', digits: 9 },
  { name: 'Portugal', iso: 'PT', dial: '+351', digits: 9 },
  { name: 'Qatar', iso: 'QA', dial: '+974', digits: 8 },
  { name: 'Romania', iso: 'RO', dial: '+40', digits: 9 },
  { name: 'Russia', iso: 'RU', dial: '+7', digits: 10 },
  { name: 'Rwanda', iso: 'RW', dial: '+250', digits: 9 },
  { name: 'Saudi Arabia', iso: 'SA', dial: '+966', digits: 9 },
  { name: 'Senegal', iso: 'SN', dial: '+221', digits: 9 },
  { name: 'Serbia', iso: 'RS', dial: '+381', digits: 9 },
  { name: 'Sierra Leone', iso: 'SL', dial: '+232', digits: 8 },
  { name: 'Singapore', iso: 'SG', dial: '+65', digits: 8 },
  { name: 'Slovakia', iso: 'SK', dial: '+421', digits: 9 },
  { name: 'Slovenia', iso: 'SI', dial: '+386', digits: 8 },
  { name: 'Somalia', iso: 'SO', dial: '+252', digits: 8 },
  { name: 'South Africa', iso: 'ZA', dial: '+27', digits: 9 },
  { name: 'South Korea', iso: 'KR', dial: '+82', digits: 10 },
  { name: 'South Sudan', iso: 'SS', dial: '+211', digits: 9 },
  { name: 'Spain', iso: 'ES', dial: '+34', digits: 9 },
  { name: 'Sri Lanka', iso: 'LK', dial: '+94', digits: 9 },
  { name: 'Sudan', iso: 'SD', dial: '+249', digits: 9 },
  { name: 'Sweden', iso: 'SE', dial: '+46', digits: 9 },
  { name: 'Switzerland', iso: 'CH', dial: '+41', digits: 9 },
  { name: 'Syria', iso: 'SY', dial: '+963', digits: 9 },
  { name: 'Taiwan', iso: 'TW', dial: '+886', digits: 9 },
  { name: 'Tajikistan', iso: 'TJ', dial: '+992', digits: 9 },
  { name: 'Tanzania', iso: 'TZ', dial: '+255', digits: 9 },
  { name: 'Thailand', iso: 'TH', dial: '+66', digits: 9 },
  { name: 'Togo', iso: 'TG', dial: '+228', digits: 8 },
  { name: 'Tunisia', iso: 'TN', dial: '+216', digits: 8 },
  { name: 'Turkey', iso: 'TR', dial: '+90', digits: 10 },
  { name: 'Turkmenistan', iso: 'TM', dial: '+993', digits: 8 },
  { name: 'Uganda', iso: 'UG', dial: '+256', digits: 9 },
  { name: 'Ukraine', iso: 'UA', dial: '+380', digits: 9 },
  { name: 'United Arab Emirates', iso: 'AE', dial: '+971', digits: 9 },
  { name: 'United Kingdom', iso: 'GB', dial: '+44', digits: 10 },
  { name: 'United States', iso: 'US', dial: '+1', digits: 10 },
  { name: 'Uruguay', iso: 'UY', dial: '+598', digits: 8 },
  { name: 'Uzbekistan', iso: 'UZ', dial: '+998', digits: 9 },
  { name: 'Venezuela', iso: 'VE', dial: '+58', digits: 10 },
  { name: 'Vietnam', iso: 'VN', dial: '+84', digits: 9 },
  { name: 'Yemen', iso: 'YE', dial: '+967', digits: 9 },
  { name: 'Zambia', iso: 'ZM', dial: '+260', digits: 9 },
  { name: 'Zimbabwe', iso: 'ZW', dial: '+263', digits: 9 },
];

export const COUNTRY_MAP_BY_ISO: Record<string, CountryData> = Object.fromEntries(
  COUNTRIES.map((c) => [c.iso, c])
);

export const COUNTRY_MAP_BY_DIAL: Record<string, CountryData> = Object.fromEntries(
  COUNTRIES.map((c) => [c.dial, c])
);

const COUNTRIES_BY_DIAL_LENGTH = [...COUNTRIES].sort((left, right) => right.dial.length - left.dial.length);

export function formatPhoneNational(dial: string, raw: string, digits: number): string {
  const trimmed = raw.trim();
  const withoutDial = trimmed.startsWith(dial) ? trimmed.slice(dial.length) : trimmed;
  const national = withoutDial.replace(/\D/g, '').slice(0, digits);
  if (national.length <= 3) return `${dial} ${national}`;
  if (national.length <= 6) return `${dial} ${national.slice(0, 3)} ${national.slice(3)}`;
  return `${dial} ${national.slice(0, 3)} ${national.slice(3, 6)} ${national.slice(6)}`;
}

export function detectCountryFromPhone(phone: string): CountryData | null {
  const compact = phone.replace(/\s/g, '');
  if (!compact.startsWith('+')) return null;
  return COUNTRIES_BY_DIAL_LENGTH.find((country) => compact.startsWith(country.dial)) || null;
}
